import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  bannerInfographic: {
    [theme.breakpoints.down('md')]: {
      display: 'grid',
      justifyItems: 'center',
      textAlign: 'center',
      marginBottom: 15,
    },
  },
  primaryColor: {
    color: '#7833FF',
  },
  whiteColor: {
    color: theme.palette.common.white,
    fontSize: 24,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
      display: 'grid',

      '& br': {
        display: 'none',
      },
    },
  },
  sectionImage: {
    display: 'block',
    maxWidth: '100%',
    margin: '0 auto',
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
  },
  primaryButton: {
    backgroundColor: '#7833FF',
  },
  whiteButton: {
    color: theme.palette.common.white,
    background: 'none',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: '#7833FF',
    },
  },
  labBg: {
    backgroundImage: 'url("/images/lab-bg.svg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
}));
